import {
	Component,
	OnInit,
	ViewChild,
	TemplateRef,
	Input,
	Output,
	EventEmitter,
	} from '@angular/core';
	import { Router } from '@angular/router';
	import { NgxSpinnerService } from 'ngx-spinner';
	import { CommonService } from 'src/app/services/common/common.service';
	import { MatDialogRef, MatDialog } from '@angular/material/dialog';
	import { StorageService } from 'src/app/services/storage/storage.service';

	import * as ApexCharts from 'apexcharts';
import { APP_CONSTANTS } from 'src/app/constants/constants';

@Component({
	selector: 'app-c-level-clients',
	templateUrl: './c-level-clients.component.html',
	styleUrls: ['./c-level-clients.component.scss']
})
export class CLevelClientsComponent implements OnInit {

	APP_CONSTANTS = APP_CONSTANTS;

	graphSlideConfig = {
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: false,
		arrows: true,
	};

	user_details: any;

	@Input() selected_opportunity_period: any;
	@Output() stateChanged = new EventEmitter<any>();

	constructor(
		private router: Router,
		public commonService: CommonService,
		private storageService: StorageService,
		private spinner: NgxSpinnerService,
		private dialog: MatDialog,
	) {}

	ngOnInit(): void {
		this.spinner.show();
		this.user_details = this.storageService.get('user_details');
		this.getTabCount();

		if (this.user_details.role.role == 4) {
			this.getDRMList();
		}

	}

	selected_tab: any = "Assigned Clients";
	tabChange(value) {
		this.selected_tab = value;
		this.getTabCount();
	}

	tab_count_data: any = {
		unassigned_clients: 0,
		assigned_clients: 0,
	};
	getTabCount() {
		let route: any = "";

		if (this.user_details.role.role == 4) {
			route = "/advisormanagerlvstepcount/";
		} else {
			route = "/advisorlvstepcount/";
		}
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.tab_count_data = res;
				this.getPageData();
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	drm_list: any = [];
	getDRMList() {
		this.commonService.getData("/getdrms/").subscribe(
			(res: any) => {
				this.drm_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	page_loaded: boolean = false;
	page_data: any;
	getPageData() {
		this.page_loaded = false;
		let route: any = "";

		if (this.selected_tab == "Assigned Clients") {
			if (this.user_details.role.role == 4) {
				route = "/advisormanagerlvassignedcharts/";
			} else {
				route = "/advisorlvassignedcharts/";
			}
		} else {
			if (this.user_details.role.role == 4) {
				route = "/advisormanagerlvcharts/";
			} else {
				route = "/advisorlvcharts/";
			}
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.page_data = res['data'];
				this.page_loaded = true;
				
				if (this.user_details.role.role == 4) {
					setTimeout(() => {
						this.createAdvisorGraph();
					}, 200);
				}
				
				this.getClientsData();
			},
			(err) => {
				this.commonService.showToast('error', err.error);
				this.page_loaded = true;
			},
		);
	}

	advisor_name: any = '';
	advisor_id: any = '';
	createAdvisorGraph() {
		let $this = this;
		var options = {
		// colors: ["#5EDEC7"],
		series: [
			{
				name: '',
				data: $this.page_data['client_by_advisor']['y-axis'],
			},
		],
		chart: {
			type: 'bar',
			events: {
			dataPointSelection: function (event, chartContext, config) {
				const details = {
				id: $this.page_data['client_by_advisor']['ids'][
					config.dataPointIndex
				],
				name: $this.page_data['client_by_advisor']['x-axis'][
					config.dataPointIndex
				],
				};
				$this.advisor_id =
				$this.advisor_id == details.id ? '' : details.id;
				$this.advisor_name =
				$this.advisor_name == details.name ? '' : details.name;
				$this.current_pagination_page = 1;

				$this.getClientsData();
			},
			},
			toolbar: {
			show: false,
			},
			zoom: {
			enabled: false,
			},
			height: 286,
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById('advisor-graph').clientWidth,
				$this.page_data['client_by_advisor']['x-axis'].length,
				20,
			),
			endingShape: 'rounded',
			// dataLabels: {
			//   position: 'bottom'
			// },
			},
		},
		dataLabels: {
			enabled: false,
			textAnchor: 'start',
			style: {
			colors: ['#000000'],
			fontWeight: '200',
			},
			formatter: function (val, opt) {
			return opt.w.globals.labels[opt.dataPointIndex];
			},
			offsetX: 0,
			dropShadow: {
			enabled: false,
			},
		},
		stroke: {
			show: true,
			width: 0,
			colors: ['transparent'],
		},
		xaxis: {
			categories: $this.page_data['client_by_advisor']['x-axis'],
			title: {
			// text: 'Age Range'
			},
			crosshairs: {
				show: false,
			},
		},
		yaxis: {
			labels: {
				// show: false,
				show: true,
			},
		},
		fill: {
			opacity: 1,
		},
		};

		var chart = new ApexCharts(
		document.querySelector('#advisor-graph'),
		options,
		);
		chart.render();
	}

	search_key: any = '';

	current_pagination_page = 1;
	total_pagination_records = 0;
	pagination_records_limit: any = 10;

	selected_alphabet = '';
	alphabets_array = [
		'A',
		'B',
		'C',
		'D',
		'E',
		'F',
		'G',
		'H',
		'I',
		'J',
		'K',
		'L',
		'M',
		'N',
		'O',
		'P',
		'Q',
		'R',
		'S',
		'T',
		'U',
		'V',
		'W',
		'X',
		'Y',
		'Z',
	];
	show_search: boolean = false;
	table_columns: any = [];
	table_data: any = [];
	selected_table_data: any = [];
	table_data_loaded: boolean = false;
	show_toggle_columns: boolean = false;
	getClientsData() {
		this.table_data_loaded = false;
		const search_key = this.search_key;

		const user_details = this.storageService.get('user_details');

		let route: any = '';

		if (this.selected_tab == "Assigned Clients") {
			if (this.user_details.role.role == 4) {
				route = '/client?records_per_page=' + this.pagination_records_limit + '&search=' + this.search_key + '&alphabet=' + this.selected_alphabet + '&page=' + this.current_pagination_page + '&advisor_manager_id=' + this.user_details.id + '&drm_assigned=true';
				if (this.advisor_id != '') {
					route = route + '&client_by_advisor=' + this.advisor_id;
				}
			} else {
				route = '/client?records_per_page=' + this.pagination_records_limit + '&search=' + this.search_key + '&alphabet=' + this.selected_alphabet + '&page=' + this.current_pagination_page + '&advisor=' + this.user_details.id + '&drm_assigned=true';
			}
		} else {
			if (this.user_details.role.role == 4) {
				route = '/client?records_per_page=' + this.pagination_records_limit + '&search=' + this.search_key + '&alphabet=' + this.selected_alphabet + '&page=' + this.current_pagination_page + '&advisor_manager_id=' + this.user_details.id + '&drm_assigned=false';
				if (this.advisor_id != '') {
					route = route + '&client_by_advisor=' + this.advisor_id;
				}
			} else {
				route = '/client?records_per_page=' + this.pagination_records_limit + '&search=' + this.search_key + '&alphabet=' + this.selected_alphabet + '&page=' + this.current_pagination_page + '&advisor=' + this.user_details.id + '&drm_assigned=false';
			}
		}

		this.commonService.getData(route).subscribe(
		(res: any) => {
			this.table_columns = res['results']['columns'];
			if (this.table_columns.length > 0) {
			for (let index = 0; index < 9; index++) {
				this.table_columns[index].checked = true;
			}
			}
			this.table_data = res['results']['data'];
			this.current_pagination_page = res.page_number;
			this.total_pagination_records = res.total_no_of_records;
			this.table_data_loaded = true;
		},
		(err) => {
			this.commonService.showToast('error', err.error);
		},
		);
	}

	pageChanged(event) {
		this.current_pagination_page = event;
		this.pagination_records_limit = this.pagination_records_limit;
		this.getClientsData();
	}

	getKey(data, column) {
		const key = column['key'];
		return data[key];
	}

	is_selected: boolean = false;
	selectAll(event) {
		if (event.checked == true) {
		this.selected_table_data = JSON.parse(JSON.stringify(this.table_data));
		this.is_selected = true;
		} else {
		this.selected_table_data = [];
		this.is_selected = false;
		}
	}

	checkIndividualSelection(data) {
		const index = this.selected_table_data.findIndex(
		(obj) => obj.id == data.id,
		);
		if (index != -1) {
		return true;
		} else {
		return false;
		}
	}

	selectIndividual(event, data) {
		const index = this.selected_table_data.findIndex(
		(obj) => obj.id == data.id,
		);
		if (index != -1) {
		if (event.checked == true) {
			this.selected_table_data.splice(index, 0, data);
		} else {
			this.selected_table_data.splice(index, 1);
		}
		} else {
		this.selected_table_data.splice(index, 0, data);
		}
		if (this.table_data.length == this.selected_table_data.length) {
		this.is_selected = true;
		} else {
		this.is_selected = false;
		}
	}



	assignClients() {
		if (this.selected_table_data.length > 0) {
			this.openassignClientsModal();
		} else {
			this.commonService.showToast('error', 'Please Select minimum one Client to Assign',);
		}
	}

	@ViewChild('assignClientsModal') assignClientsModal: TemplateRef<any>;
	private assignClientsModalRef: MatDialogRef<TemplateRef<any>>;

	clients_loader = false;
	assigned_drm: any = "";
	assigned_drm_error: boolean = false;
	openassignClientsModal() {
		this.assignClientsModalRef = this.dialog.open(this.assignClientsModal, { disableClose: true });
			this.assignClientsModalRef.afterClosed().subscribe((result) => {
			this.closeAssignClientsModal();
		});
	}

	closeAssignClientsModal() {
		this.assigned_drm = "";
		this.assigned_drm_error = false;
		this.clients_loader = false;
		this.assignClientsModalRef.close();
	}

	assignClientsData() {
		if (this.assigned_drm != '' && this.assigned_drm != null) {
			this.assigned_drm_error = false;
		} else {
			this.assigned_drm_error = true;
		}

		if (this.assigned_drm_error == false) {
			this.clients_loader = true;
		let payload: any = {
			drm_id: this.assigned_drm,
			clients: [],
		};

		for (let index = 0; index < this.selected_table_data.length; index++) {
			payload.clients.push(this.selected_table_data[index].id);
		}

		this.commonService.postData('/assigndrm/', payload).subscribe(
			(res: any) => {
				this.selected_table_data = [];
				this.getTabCount();
				this.commonService.showToast('success', 'Clients Assigned Successfully.',);


				this.closeAssignClientsModal();
				this.clients_loader = false;
			},
			(err) => {
				this.clients_loader = false;
				this.commonService.showToast('error', err.error);
			},
		);
		}

	}

	unAssignClients() {
		if (this.selected_table_data.length > 0) {
			this.openUnassignClientsModal();
		} else {
			this.commonService.showToast('error', 'Please Select minimum one Client to Unassign',);
		}
	}

	@ViewChild('unassignClientsModal') unassignClientsModal: TemplateRef<any>;
	private unassignClientsModalRef: MatDialogRef<TemplateRef<any>>;
	openUnassignClientsModal() {
		this.unassignClientsModalRef = this.dialog.open(this.unassignClientsModal, { disableClose: true });
		this.unassignClientsModalRef.afterClosed().subscribe((result) => {
			this.closeUnAssignClientsModal();
		});
	}

	closeUnAssignClientsModal() {
		this.assigned_drm = "";
		this.assigned_drm_error = false;
		this.clients_loader = false;
		this.unassignClientsModalRef.close();
	}

	unAssignClientsData() {

			this.clients_loader = true;
			let payload: any = {
				clients: [],
			};

			for (let index = 0; index < this.selected_table_data.length; index++) {
				payload.clients.push(this.selected_table_data[index].id);
			}

			this.commonService.postData('/unassigndrm/', payload).subscribe(
				(res: any) => {
					this.selected_table_data = [];
					this.getTabCount();
					this.commonService.showToast('success', 'Clients UnAssigned Successfully.',);


					this.closeUnAssignClientsModal();
					this.clients_loader = false;
				},
				(err) => {
					this.clients_loader = false;
					this.commonService.showToast('error', err.error);
				},
			);
		}
	
	back() {
		const data = {
			clickable: true,
			name: 'Summary',
		};
		this.stateChanged.emit(data);
	}

	show_user_profile: boolean = false;
		user_profile_data: any;
		showUserProfile(data) {
		this.user_profile_data = JSON.parse(JSON.stringify(data));
		this.show_user_profile = true;
		}

		profileClosed(event) {
		this.user_profile_data = {};
		this.show_user_profile = false;
		}

		description_sections: any = [
		{
			name: "The definition for the section detailing the total c level clients within an advisor's existing book of business can be broken down into several parts for clarity:",
			sub_sections: [
				{
					name: "Overview",
					value: "This section is crafted to enlighten advisors on the breadth of untapped clients residing within their current book of business. It's a strategic tool designed to spotlight potential areas of growth and client engagement."
				},
				{
					name: "Trigger Event Business Rules",
					value: "Incorporated within this are opportunities unearthed through trigger event business rules. These rules are a curated set of indicators developed by industry experts. They signal the optimal moments and rationales for when a client might be inclined to invest in the next recommended product."
				},
				{
					name: "AI-Driven Opportunities",
					value: "Additionally, the section includes AI-driven opportunities that would typically go unnoticed without the intervention of advanced analytics. This AI model is a powerful asset, extending the advisor's insight beyond traditional methods and revealing hidden prospects for client investment."
				},
				{
					name: "Navigation",
					value: "Advisors can navigate through these opportunities by clicking on the indicated arrow. This action unfolds a detailed breakdown, categorizing opportunities by their origin—be it AI-generated or triggered by specific events. It also segments them based on their propensity to close promptly and their estimated value."
				},
				{
					name: "Ranking System",
					value: "Crucially, all opportunities are ranked to assist advisors in prioritizing their efforts. This ranking is meticulously designed to steer advisors towards opportunities that not only possess high value but also exhibit a shorter timespan for deal closure."
				},
				{
					name: "Purpose",
					value: "The ultimate goal of this section is to equip advisors with a prioritized, insightful view of their book of business, enabling them to concentrate on the most promising and lucrative opportunities for expanding their client's investment portfolio. It's a blend of expert knowledge and machine learning precision, all tailored to enhance the advisor's efficiency and success rate."
				},
			]
		},
	];

	}
